import FormTemplate from "./FormTemplate.vue"
import InputBox from "./FormElements/Fields/InputBox.vue"
import TextArea from "./FormElements/Fields/TextArea.vue"
import RadioButton from "./FormElements/Fields/RadioButton.vue"
import CheckBox from "./FormElements/Fields/CheckBox.vue"
import DateBox from "./FormElements/Fields/DateBox.vue"
import UploadBox from "./FormElements/Fields/UploadBox.vue"
import DropdownBox from "./FormElements/Fields/DropdownBox.vue"

const COMPONENT_MAP = {
  formTemplate: FormTemplate,
  text: InputBox,
  textarea: TextArea,
  radio: RadioButton,
  check: CheckBox,
  date: DateBox,
  upload: UploadBox,
  dropdown: DropdownBox,
}

export function getComponent(type) {
  return COMPONENT_MAP[type]
}
